import React from 'react'
import { get, TextBody } from '@ally/metronome-ui'
import styled from 'styled-components'

const PromptTextBody = styled(TextBody)`
  padding-left: ${get.space('xs')};
`
const PromptAcctWrapper = styled.div`
  padding-top: ${get.space('xs')};
  padding-left: 30px;
  padding-right: 30px;
  &:after {
    content: '';
    margin: auto;
    width: 100%;
    display: block;
    padding-top: ${get.space('xs')};
    border-bottom: thin solid ${get.colors('slate-2')};
  }
`

const RaiseYourRateWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  ${get.media.down('sm')} {
    flex-direction: column;
    gap: ${get.space('md')};
    padding: ${get.space('xs')} 0;
  }
`

export const ActionPromptItem: React.FC<{ id?: string }> = ({
  children,
  id,
}) => (
  <PromptAcctWrapper data-testid="action-prompt">
    <PromptTextBody size="md" tag="p" weight="normal" data-testid={id || ''}>
      {children}
    </PromptTextBody>
  </PromptAcctWrapper>
)

export const ActionPromptItemRyr: React.FC<{
  id?: string
}> = ({ children, id }) => (
  <PromptAcctWrapper data-testid="action-prompt">
    <RaiseYourRateWrapper>{children}</RaiseYourRateWrapper>
  </PromptAcctWrapper>
)
